const AnchorDownIcon = ({className} : {className?:string}) => {
  return (
<svg className={className} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.7496 3.75004H2.24957C2.11289 3.75047 1.97891 3.78817 1.86206 3.85908C1.74521 3.92999 1.64991 4.03142 1.58642 4.15246C1.52293 4.2735 1.49366 4.40956 1.50174 4.54601C1.50983 4.68245 1.55497 4.8141 1.63232 4.92679L8.38232 14.6768C8.66207 15.081 9.33557 15.081 9.61607 14.6768L16.3661 4.92679C16.4442 4.81434 16.49 4.68262 16.4985 4.54595C16.5071 4.40928 16.478 4.27289 16.4144 4.15159C16.3509 4.03029 16.2553 3.92873 16.1381 3.85793C16.0209 3.78714 15.8865 3.74983 15.7496 3.75004Z" fill="#2058AD"/>
</svg>
  )
}

export default AnchorDownIcon